//locale.fa.js
const AG_GRID_LOCALE_FA = {
  // Set Filter
  selectAll: '(انتخاب همه)',
  selectAllSearchResults: '(انتخاب همه نتایج)',
  searchOoo: 'جستجو...',
  blanks: '(خالی)',
  noMatches: 'پیدا نشد',

  // Number Filter & Text Filter
  filterOoo: 'فیلتر...',
  equals: 'برابر است',
  notEqual: 'برابر نیست',
  blank: 'خالی',
  notBlank: 'خالی نیست',
  empty: 'یکی انتخاب کن',

  // Number Filter
  lessThan: 'کمتر از',
  greaterThan: 'بزرگتر از',
  lessThanOrEqual: 'کمتر یا مساوی',
  greaterThanOrEqual: 'بزرگتر یا مساوی',
  inRange: 'در محدوده',
  inRangeStart: 'از',
  inRangeEnd: 'تا',

  // Text Filter
  contains: 'شامل',
  notContains: 'شامل نباشه',
  startsWith: 'شروع با',
  endsWith: 'پایان با',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'و',
  orCondition: 'یا',

  // Filter Buttons
  applyFilter: 'اعمال',
  resetFilter: 'ریست',
  clearFilter: 'پاک کردن',
  cancelFilter: 'لغو',

  // Filter Titles
  textFilter: 'فیلتر متن',
  numberFilter: 'فیلتر شماره',
  dateFilter: 'فیلتر تاریخ',
  setFilter: 'تنظیم فیلتر',

  // Side Bar
  columns: 'ستون‌ها',
  filters: 'فیلترها',

  // columns tool panel
  pivotMode: 'مدل Pivot',
  groups: 'گروه‌های ردیف',
  rowGroupColumnsEmptyMessage: 'برای تنظیم گروه های ردیف به اینجا بکشید',
  values: 'مقدار',
  valueColumnsEmptyMessage: 'برای جمع‌آوری اینجا بکشید',
  pivots: 'عنوان‌های ستون',
  pivotColumnsEmptyMessage: 'برای تنظیم عنوان‌های ستون به اینجا بکشید',

  // Header of the Default Group Column
  group: 'گروه',

  // Row Drag
  rowDragRows: 'ردیف',

  // Other
  loadingOoo: 'در حال بارگذاری اطلاعات ...',
  noRowsToShow: 'داده ای برای نمایش وجود ندارد.',
  enabled: 'Enabled',

  // Menu
  pinColumn: 'چسبیدن ستون',
  pinLeft: 'به چپ بچسب',
  pinRight: 'به راست بچسب',
  noPin: 'نچسب',
  valueAggregation: 'تجمیع ارزش',
  autosizeThisColumn: 'تنظیم اندازه ستون',
  autosizeAllColumns: 'تنظیم اندازه همه ستون‌ها',
  groupBy: 'گروه‌بندی براساس',
  ungroupBy: 'عدم گروه‌بندی براساس',
  addToValues: 'اضافه ${variable} به مقدار',
  removeFromValues: 'حذف ${variable} از مقدار',
  addToLabels: 'اضافه ${variable} به برچسب‌ها',
  removeFromLabels: 'حذف ${variable} از برچسب‌ها',
  resetColumns: 'ریست ستون‌ها',
  expandAll: 'بازکردن همه',
  collapseAll: 'بستن همه',
  copy: 'رونوشت',
  ctrlC: 'کنترل+C',
  copyWithHeaders: 'رونوشت با سربرگ',
  copyWithHeaderGroups: 'رونوشت با گروه‌ سربرگ',
  copywithGroupHeaders: 'رونوشت با گروه‌ سربرگ',
  paste: 'جاگذاری',
  ctrlV: 'کنترل+V',
  export: 'خروجی گرفتن',
  csvExport: 'خروجی CSV',
  excelExport: 'خروجی Excel',
  columnFilter: 'فیلتر ستون ها',
  columnChooser: 'انتخاب ستون ها',
  sortAscending: 'مرتب سازی صعودی',
  sortDescending: 'مرتب سازی نزولی',
  sortUnSort: 'حذف مرتب سازی',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'جمع',
  min: 'حداقل',
  max: 'حداکثر',
  none: 'هیچ',
  count: 'تعداد',
  avg: 'میانگین',
  filteredRows: 'فیلتر شده',
  selectedRows: 'انتخاب شده',
  totalRows: 'تعداد ردیف‌ها',
  totalAndFilteredRows: 'ردیف‌ها',
  more: 'بیشتر',
  to: 'تا',
  of: 'از',
  page: 'صفحه',
  nextPage: 'صفحه بعدی',
  lastPage: 'آخرین صفحه',
  firstPage: 'صفحه اول',
  previousPage: 'صفحه قبلی',
  pageSizeSelectorLabel: 'اندازه صفحه:',

  // Pivoting
  pivotColumnGroupTotals: 'جمع',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'مدل و نمودار Pivot',
  pivotChart: 'نمودار Pivot',
  chartRange: 'نمودارها',

  columnChart: 'ستون',
  groupedColumn: 'گروه‌بندی شده',
  stackedColumn: 'انباشته',
  normalizedColumn: '100% انباشته',

  barChart: 'میله‌ای',
  groupedBar: 'گروه‌بندی شده',
  stackedBar: 'انباشته',
  normalizedBar: '100% انباشته',

  pieChart: 'دایره‌ای',
  pie: 'دایره‌ای',
  doughnut: 'دونات',

  line: 'خطی',

  xyChart: 'X Y (پراکندگی)',
  scatter: 'پراکندگی',
  bubble: 'حبابی',

  areaChart: 'مساحت',
  area: 'مساحت',
  stackedArea: 'انباشته',
  normalizedArea: '100% انباشته',

  histogramChart: 'هیستوگرام',

  combinationChart: 'ترکیبی',
  columnLineCombo: 'ستون و خطی',
  AreaColumnCombo: 'مساحت و ستون',

  // Charts
  pivotChartTitle: 'نمودار Pivot',
  rangeChartTitle: 'نمودارها',
  settings: 'تنظیمات',
  data: 'داده',
  format: 'قالب',
  categories: 'دسته‌ها',
  defaultCategory: '(هیچ)',
  series: 'مجموعه‌ها',
  xyValues: 'X Y نقدار',
  paired: 'حالت جفت',
  axis: 'محور',
  navigator: 'ناوبر',
  color: 'رنگ',
  thickness: 'ضخامت',
  xType: 'X نوع',
  automatic: 'خودکار',
  category: 'دسته',
  number: 'عدد',
  time: 'زمان',
  xRotation: 'X چرخش',
  yRotation: 'Y چرخش',
  ticks: 'تیک‌ها',
  width: 'عرض',
  height: 'ارتفاع',
  length: 'طول',
  padding: 'فاصله اطراف',
  spacing: 'فاصله',
  chart: 'نمودار',
  title: 'عنوان',
  titlePlaceholder: 'عنوان نمودار - برای ویرایش دوبار کلیک کنید',
  background: 'پس زمینه',
  font: 'فونت',
  top: 'بالا',
  right: 'راست',
  bottom: 'پایین',
  left: 'چپ',
  labels: 'برچسب‌ها',
  size: 'اندازه',
  minSize: 'حداقل اندازه',
  maxSize: 'حداکثر اندازه',
  legend: 'شرح',
  position: 'موقعیت',
  markerSize: 'اندازه نشانگر',
  markerStroke: 'ضخامت نشانگر',
  markerPadding: 'فاصله نشانگر',
  itemSpacing: 'فاصله موارد',
  itemPaddingX: 'فاصله داخلی موارد X',
  itemPaddingY: 'فاصله داخلی موارد Y',
  layoutHorizontalSpacing: 'فاصله افقی',
  layoutVerticalSpacing: 'فاصله عمودی',
  strokeWidth: 'عرض اندازه',
  offset: 'انحراف',
  offsets: 'انحراف‌ها',
  tooltips: 'تولتیپ‌ها',
  callout: 'فراخوانی',
  markers: 'نشانگرها',
  shadow: 'سایه',
  blur: 'تاری',
  xOffset: 'X انحراف',
  yOffset: 'Y انحراف',
  lineWidth: 'عرض خط',
  normal: 'معمولی',
  bold: 'پررنگ',
  italic: 'مورب',
  boldItalic: 'پررنگ مورب',
  predefined: 'از پیش تعریف شده',
  fillOpacity: 'تاری داخل خط',
  strokeOpacity: 'تاری خط',
  histogramBinCount: 'تعداد بن',
  columnGroup: 'ستون',
  barGroup: 'میله',
  pieGroup: 'دایره',
  lineGroup: 'خطی',
  scatterGroup: 'X Y (ترکیبی)',
  areaGroup: 'مساحت',
  histogramGroup: 'هیستوگرام',
  combinationGroup: 'ترکیبی',
  groupedColumnTooltip: 'گروه‌بندی شده',
  stackedColumnTooltip: 'انباشته',
  normalizedColumnTooltip: '100% انباشته',
  groupedBarTooltip: 'گروه‌بندی شده',
  stackedBarTooltip: 'انباشته',
  normalizedBarTooltip: '100% انباشته',
  pieTooltip: 'دایره',
  doughnutTooltip: 'دونات',
  lineTooltip: 'خطی',
  groupedAreaTooltip: 'مساحت',
  stackedAreaTooltip: 'انباشته',
  normalizedAreaTooltip: '100% انباشته',
  scatterTooltip: 'پراکندگی',
  bubbleTooltip: 'حبابی',
  histogramTooltip: 'هیستوگرام',
  columnLineComboTooltip: 'ستون و خطی',
  areaColumnComboTooltip: 'مساحت و ستون',
  customComboTooltip: 'ترکیبی سفارشی',
  noDataToChart: 'داده ای برای ترسیم نمودار موجود نیست.',
  pivotChartRequiresPivotMode:
    'نمودار Pivot نیاز به فعال سازی حالت Pivot داره.',
  chartSettingsToolbarTooltip: 'ناوبری',
  chartLinkToolbarTooltip: 'اتصال به جدول',
  chartUnlinkToolbarTooltip: 'عدم اتصال به جدول',
  chartDownloadToolbarTooltip: 'بارگیری نمودار',

  seriesChartType: 'نوع نمودار مجموعه‌ها',
  seriesType: 'نوع مجموعه‌ها',
  secondaryAxis: 'دامین محور',

  // ARIA
  ariaHidden: 'پنهان',
  ariaVisible: 'قابل مشاهده',
  ariaChecked: 'انتخاب شده',
  ariaUnchecked: 'عدم انتخاب',
  ariaIndeterminate: 'نامعین',
  ariaDefaultListName: 'لیست',
  ariaColumnSelectAll: 'تغییر انتخاب همه ستونها',
  ariaInputEditor: 'ویرایشگر ورودی',
  ariaDateFilterInput: 'ورودی فیلتر تاریخ',
  ariaFilterList: 'لیست فیلتر',
  ariaFilterInput: 'ورودی فیلتر',
  ariaFilterColumnsInput: 'ورودی ستون‌های فیلتر',
  ariaFilterValue: 'مقدار فیلتر',
  ariaFilterFromValue: 'فیلتر از مقدار',
  ariaFilterToValue: 'فیلتر تا مقدار',
  ariaFilteringOperator: 'فیلترینگ عملگر ',
  ariaColumn: 'ستون',
  ariaColumnList: 'لیست ستون',
  ariaColumnGroup: 'گروه ستون',
  ariaRowSelect: 'برای انتخاب این سطر، SPACE را فشار دهید.',
  ariaRowDeselect: 'برای لغو انتخاب این سطر، SPACE را فشار دهید.',
  ariaRowToggleSelection: 'برای جابجایی انتخاب ردیف، Space را فشار دهید',
  ariaRowSelectAll: 'برای تغییر دادن انتخاب همه ردیف‌ها، Space را فشار دهید.',
  ariaToggleVisibility: 'برای تغییر حالت دید، SPACE را فشار دهید.',
  ariaSearch: 'جستجو',
  ariaSearchFilterValues: 'مقادیر فیلتر جستجو',

  ariaRowGroupDropZonePanelLabel: 'گروه های ردیف',
  ariaValuesDropZonePanelLabel: 'مقادیر',
  ariaPivotDropZonePanelLabel: 'برچسب های ستون',
  ariaDropZoneColumnComponentDescription: 'برای حذف DELETE را فشار دهید',
  ariaDropZoneColumnValueItemDescription:
    'برای تغییر نوع تجمیع، ENTER را فشار دهید',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'ناوبری ستون',
  ariaLabelCellEditor: 'ویرایشگر سلول',
  ariaLabelDialog: 'دیالوگ',
  ariaLabelSelectField: 'انتخاب رشته',
  ariaLabelTooltip: 'تولتیپ',
  ariaLabelContextMenu: 'متن ناوبری',
  ariaLabelSubMenu: 'ناوبری دوم',
  ariaLabelAggregationFunction: 'عملکرد تجمیع',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.'
};
export default AG_GRID_LOCALE_FA;
